import { render, staticRenderFns } from "./CustomerLoyalties.vue?vue&type=template&id=3c4a4518&scoped=true"
import script from "./CustomerLoyalties.vue?vue&type=script&lang=ts"
export * from "./CustomerLoyalties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a4518",
  null
  
)

export default component.exports